module.exports = __webpack_public_path__ + "static/img/img10.50135c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img10.png
// module id = /CWC
// module chunks = 1